import { INgayNghiLe } from "../../../model/respone/category/INgayNghiLe";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eNgayNghiLeActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as INgayNghiLe[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as INgayNghiLe | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as INgayNghiLe,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eNgayNghiLeActionIds = generateActionTypeIds(
  eNgayNghiLeActionsObj,
  "NGAY_NGHI_LE"
);

export type INgayNghiLeActionTypes = IGenericActionType<
  typeof eNgayNghiLeActionsObj,
  "NGAY_NGHI_LE"
>;
